import { useEffect, ReactNode } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import useFetchSpecificCampaign from 'queries/fetch/fetchSpecificCampaign.ts';
import { ICampaignLevelParams } from 'utils/parameterUtils';

interface CampaignLoaderProps {
  children: ReactNode;
}

function CampaignLoader({ children }: CampaignLoaderProps) {
  const navigate = useNavigate();
  const { campaignId, teamId } = useParams() as ICampaignLevelParams;

  const { isError } = useFetchSpecificCampaign({
    teamId,
    campaignId,
    enabled: !!campaignId && campaignId !== 'new',
  });

  useEffect(() => {
    if (isError) {
      navigate('/notfound');
    }
  }, [isError, navigate]);

  return children;
}

export default CampaignLoader;
